"use client";

import { c as _c } from "react/compiler-runtime";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import { RatingStats } from "@/entities/IProfile";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import UserPageRepModifyModal from "../modify-rep/UserPageRepModifyModal";
import { AnimatePresence } from "framer-motion";
export default function UserPageRepsItem(t0) {
  const $ = _c(43);
  const {
    rep,
    profile,
    canEditRep
  } = t0;
  const isPositiveRating = rep.rating > 0;
  const [isEditRepModalOpen, setIsEditRepModalOpen] = useState(false);
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsEditRepModalOpen(true);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !canEditRep;
  const t5 = `${canEditRep ? "hover:tw-bg-iron-700" : ""} tw-flex tw-items-center tw-justify-between tw-gap-x-2 tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-inset tw-ring-iron-700 
           tw-px-3 tw-py-1.5 sm:tw-py-1 tw-transition tw-duration-300 tw-ease-out`;
  let t6;
  if ($[3] !== rep.category) {
    t6 = <span className="tw-whitespace-nowrap tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-50">{rep.category}</span>;
    $[3] = rep.category;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = `${isPositiveRating ? "tw-text-green" : "tw-text-red"} tw-whitespace-nowrap tw-font-medium tw-text-sm sm:tw-text-md`;
  const t8 = `rep-${rep.category}-${rep.rating}`;
  let t9;
  if ($[5] !== rep.rating) {
    t9 = formatNumberWithCommas(rep.rating);
    $[5] = rep.rating;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t8 || $[8] !== t9) {
    t10 = <span data-tooltip-id={t8}>{t9}</span>;
    $[7] = t8;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== isTouchScreen || $[11] !== rep.category || $[12] !== rep.rater_contribution || $[13] !== rep.rating) {
    t11 = !isTouchScreen && !!rep.rater_contribution ? <Tooltip id={`rep-${rep.category}-${rep.rating}`} place="top" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>My Rep: {formatNumberWithCommas(rep.rater_contribution)}</Tooltip> : null;
    $[10] = isTouchScreen;
    $[11] = rep.category;
    $[12] = rep.rater_contribution;
    $[13] = rep.rating;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t7) {
    t13 = <span className={t7}>{t12}</span>;
    $[18] = t12;
    $[19] = t7;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== rep.contributor_count) {
    t14 = formatNumberWithCommas(rep.contributor_count);
    $[21] = rep.contributor_count;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const t15 = rep.contributor_count === 1 ? "rater" : "raters";
  let t16;
  if ($[23] !== t14 || $[24] !== t15) {
    t16 = <span className="tw-whitespace-nowrap tw-text-sm sm:tw-text-sm tw-font-medium tw-text-iron-400">({t14}{" "}{t15})</span>;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t13 || $[27] !== t16 || $[28] !== t5 || $[29] !== t6) {
    t17 = <span className={t5}>{t6}{t13}{t16}</span>;
    $[26] = t13;
    $[27] = t16;
    $[28] = t5;
    $[29] = t6;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17 || $[32] !== t4) {
    t18 = <button onClick={t3} disabled={t4} className="tw-bg-transparent tw-border-none tw-p-0 ">{t17}</button>;
    $[31] = t17;
    $[32] = t4;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== isEditRepModalOpen || $[35] !== profile || $[36] !== rep.category) {
    t19 = isEditRepModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-10" elementRole="dialog" onClicked={_temp}><UserPageRepModifyModal profile={profile} category={rep.category} onClose={() => setIsEditRepModalOpen(false)} /></CommonAnimationOpacity>;
    $[34] = isEditRepModalOpen;
    $[35] = profile;
    $[36] = rep.category;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t19) {
    t20 = <AnimatePresence mode="sync" initial={true}>{t19}</AnimatePresence>;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t18 || $[41] !== t20) {
    t21 = <>{t18}{t20}</>;
    $[40] = t18;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  return t21;
}
function _temp(e) {
  return e.stopPropagation();
}